import React, { useEffect, useState } from "react";
import Errors from "../../components/Errors";
import Container from "../../components/Container";
import CardsGridContainer from "../../components/CardsGridContainer";

import * as S from "./styles";
import Banner from "../../components/Banner";
import PageTitle from "../../components/PageTitle";
import apiCDS from "../../services/apiCDS";

const CategoryDetails = (props) => {
  const { id } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [hasContent, setHasContent] = useState(true);
  const [currentCategory, setCurrentCategory] = useState([]);
  const [Category, setCategory] = useState("");

  const getContent = async () => {
    try {
      setLoading(true);
      const response = await apiCDS.get("/categories/courses");
      const data = response.data.find((category) => category.id === id);
      setCurrentCategory(data.courses);
      setCategory(data.title);
      setLoading(false);
    } catch (e) {
      console.error("ERRO: ", e);
      setHasContent(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    getContent();
  }, [id]);

  if (loading) {
    return (
      <S.SpinnerContainer>
        <div className="spinner" />
      </S.SpinnerContainer>
    );
  }

  if (!hasContent) {
    return <Errors status={404} />;
  }

  return (
    <Container type={"clean"}>
      <Banner />

      <PageTitle>{Category}</PageTitle>

      {currentCategory.length > 0 ? (
        <CardsGridContainer content={currentCategory} />
      ) : (
        <p>Não há cursos nessa categoria</p>
      )}
    </Container>
  );
};

export default CategoryDetails;
